<script setup>
import KanbanCard from '../cards/KanbanCard.vue';

const props = defineProps({
  dayLabel: { type: String, required: true },
  dayNumber: { type: [String, Number], required: true },
  isToday: { type: Boolean, default: false },
  tasks: { type: Array, default: () => [] },
  dayIndex: { type: Number, required: true }
});

const emit = defineEmits(['create-task', 'select-task', 'dragstart', 'dragover-task', 'drop-task', 'drop-column']);

const onDragOverColumn = (event) => {
  event.preventDefault();
};
</script>

<template>
  <div
    class="kanban-collum"
    :class="{ 'today-column': isToday }"
    @dragover.prevent="onDragOverColumn"
    @drop="emit('drop-column', dayLabel, dayIndex)"
  >
    <div class="d-flex justify-content-between align-items-center w-100 mb-3 px-1">
      <div class="column-header-text">
        <span class="text-uppercase mr-1 text-secondary"><b>{{ dayLabel.slice(0, 3) }}</b></span>
        <span class="text-dark"><b>{{ dayNumber }}</b></span>
        <span v-if="isToday" class="text-primary-custom ml-1"><b>(hoje)</b></span>
      </div>
      <button type="button" class="btn-add-task-icon" @click="emit('create-task', dayIndex)" title="Nova tarefa">
        <i class="fa-solid fa-plus"></i>
      </button>
    </div>

    <div class="kanban-task-list">
      <transition-group name="move" tag="div">
        <KanbanCard
          v-for="(task, tIndex) in tasks"
          :key="task.id || tIndex"
          :task="task"
          @select="emit('select-task', $event)"
          @dragstart="emit('dragstart', $event, dayLabel)"
          @dragover="emit('dragover-task', $event)"
          @drop="emit('drop-task', $event)"
        />
      </transition-group>
    </div>
  </div>
</template>

<style scoped>
.kanban-collum {
  border: 1px solid #dee2e6;
  border-radius: 8px;
  padding: 8px;
  flex: 1;
  min-width: 0;
  min-height: 680px;
  background-color: #E9ECEF;
}

.today-column {
  border: 2px solid #F1860B !important;
}

.text-primary-custom {
  color: #F1860B !important;
}

.column-header-text {
  font-size: 13px;
}

.btn-add-task-icon {
  background: transparent;
  border: none;
  color: #6C757D;
  font-size: 14px;
  cursor: pointer;
  padding: 2px;
  transition: color 0.15s;
}

.btn-add-task-icon:hover {
  color: #F1860B;
}

.move-enter-active, .move-leave-active {
  transition: transform 0.25s ease, opacity 0.25s ease;
}

.move-enter, .move-leave-to {
  transform: translateY(20px);
  opacity: 0;
}
</style>